/**
 * Cookie utility functions for FCM token storage
 */

import { vendorDataResponse } from "../models/axiosModel";

const FCM_TOKEN_COOKIE_NAME = 'chronox_fcm_token';
const FCM_TOKEN_COOKIE_MAX_AGE = 90 * 24 * 60 * 60; // 3 Months in Seconds

export const getParentDomainForCookie = (vendorData: vendorDataResponse | null) => {
  if(vendorData){
    const domain = vendorData?.vendor_domain ?? "";
    const parts = domain.split(".");

    if(parts.length <= 2){
      return "." + domain;
    } else {
      return "." + parts?.slice(-2)?.join(".");
    }
  } else {
    const hostname = window.location.hostname?.toLowerCase();
    if(hostname === 'app.chronox.in'){
      return ".chronox.in";
    }
    return ".chronox.ai";
  }
}

/**
 * Set FCM token in cookie
 */
export const setFCMTokenCookie = (token: string, vendorData: vendorDataResponse | null): void => {
  try {
    // Set cookie with path=/ so it's accessible across the entire site
    // SameSite=Lax for security while allowing cross-site navigation
    const expires = new Date();
    expires.setTime(expires.getTime() + FCM_TOKEN_COOKIE_MAX_AGE * 1000);

    const parentDomain = getParentDomainForCookie(vendorData);
    
    document.cookie = `${FCM_TOKEN_COOKIE_NAME}=${encodeURIComponent(token)}; domain=${parentDomain}; path=/; expires=${expires.toUTCString()}; SameSite=Lax`;
    console.log('[FCM Cookie] Token stored in cookie');
  } catch (error) {
    console.error('[FCM Cookie] Error setting FCM token cookie:', error);
  }
};

/**
 * Get FCM token from cookie
 */
export const getFCMTokenCookie = (): string | null => {
  try {
    const name = FCM_TOKEN_COOKIE_NAME + '=';
    const decodedCookie = decodeURIComponent(document.cookie);
    const cookieArray = decodedCookie.split(';');
    
    for (let i = 0; i < cookieArray.length; i++) {
      let cookie = cookieArray[i];
      while (cookie.charAt(0) === ' ') {
        cookie = cookie.substring(1);
      }
      if (cookie.indexOf(name) === 0) {
        const token = cookie.substring(name.length, cookie.length);
        console.log('[FCM Cookie] Token retrieved from cookie');
        return token;
      }
    }
    
    console.log('[FCM Cookie] No token found in cookie');
    return null;
  } catch (error) {
    console.error('[FCM Cookie] Error getting FCM token from cookie:', error);
    return null;
  }
};

/**
 * Remove FCM token from cookie
 */
export const removeFCMTokenCookie = (vendorData: vendorDataResponse | null): void => {
  try {
    // Set expiration date in the past to delete the cookie

    const parentDomain = getParentDomainForCookie(vendorData);

    document.cookie = `${FCM_TOKEN_COOKIE_NAME}=; domain=${parentDomain}; path=/; expires=Thu, 01 Jan 1970 00:00:00 UTC; SameSite=Lax`;
    console.log('[FCM Cookie] Token removed from cookie');
  } catch (error) {
    console.error('[FCM Cookie] Error removing FCM token cookie:', error);
  }
};

